import { Box, Stack, Modal, Backdrop } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useAppSelector } from "~/app/store";
import { useNavbar } from "~/hooks/useNavbar";

import {
  clearAndonWorkstationsAndGrids,
  setAndonViewOption,
  selectCurrentAndonBoardView
} from "./andon.slice";
import AndonBoard from "./andonBoard/AndonBoard";

export function Andon(): JSX.Element {
  const dispatch = useDispatch();

  const andonViewOption = useAppSelector(selectCurrentAndonBoardView);
  const isFullScreen = andonViewOption === "board fullscreen";
  const { setMenuItems } = useNavbar({
    isHidden: isFullScreen,
    viewTitle: "nav.viewname.service and support"
  });

  useEffect(() => {
    setMenuItems([
      {
        textContent: "Clear Andon Statuses",
        trackingLabel: "Clear Andon Statuses",
        actionCb: () => {
          dispatch(clearAndonWorkstationsAndGrids());
        }
      }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Normal page content - always visible */}
      <Stack
        id="andon-container"
        sx={{
          width: "100%",
          height: "100%"
        }}
      >
        <Box
          id="tab-content"
          flexGrow={1}
          sx={{
            height: "100%",
            width: "100%",
            overflowX: "hidden"
          }}
        >
          <AndonBoard />
        </Box>
      </Stack>

      {/* Fullscreen overlay modal */}
      <Modal
        open={andonViewOption === "board fullscreen"}
        onClose={() => dispatch(setAndonViewOption("default"))}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            sx: { backgroundColor: "rgba(255, 255, 255, 1)" }
          }
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            outline: "none"
          }}
          onClick={() => dispatch(setAndonViewOption("default"))}
          role="button"
          aria-label="exit full screen"
          tabIndex={0}
          onKeyDown={(event) => {
            if (
              event.key === "Escape" ||
              event.key === "Enter" ||
              event.key === " "
            ) {
              event.preventDefault();
              dispatch(setAndonViewOption("default"));
            }
          }}
        >
          <AndonBoard />
        </Box>
      </Modal>
    </>
  );
}

export default Andon;
